import React from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { useStyletron } from 'baseui';
import { Card } from 'commons-ui';

import usePermission from 'routes/usePermission';
import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { ACL_ENTITIES, Entity, GAME_ADMIN_RESOURCES, PAGE_NAMES } from 'constant';

import { URL, LABEL, IMAGE_SOURCE } from './helper';

const useGameAdminHome = () => {
	const { hasPermission } = usePermission();
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	const isEnabled = (entity: Entity) => {
		if (ACL_ENTITIES.includes(entity)) {
			return hasPermissionV2({
				configPageName: PAGE_NAMES.gameAdmin,
				configResourceName: entity
			});
		}
		return hasPermission({
			configPageName: PAGE_NAMES.gameAdmin,
			entity
		});
	};

	return { isEnabled };
};

const GameAdminHome: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { isEnabled } = useGameAdminHome();

	return (
		<div
			className={css({
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-evenly',
				alignItems: 'center',
				height: '100%',
				flexWrap: 'wrap',
				gap: '50px'
			})}>
			{_map(_keys(GAME_ADMIN_RESOURCES), (entity: Entity) => {
				return isEnabled(entity) ? (
					<div
						key={entity}
						className={css({
							height: '130px',
							width: '40%',
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-around'
						})}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[entity]);
						}}>
						<Card label={LABEL[entity]} img={IMAGE_SOURCE[entity]} />
					</div>
				) : null;
			})}
		</div>
	);
};

export default GameAdminHome;
